// Update store with getAppointment response

import { mutatorAction } from 'satcheljs';
import appointmentStore from '../store/AppointmentStore';
import type { GetAppointmentResponse } from 'bookings-shared/lib/c2/services/schema/getAppointment';

export default mutatorAction('SET_GET_APPOINTMENT_RESPONSE', (response: GetAppointmentResponse) => {
    appointmentStore.getAppointmentResponse = response;
});
